{
	"termsAndConditions": {
		"title": "Smluvní podmínky",
		"submitTitle": "Přijmout a pokračovat v Zásadách ochrany osobních údajů"
	},
	"privacyPolicy": {
		"title": "Zásady ochrany osobních údajů",
		"submitTitle": "Přijmout a zavřít",
		"backTitle": "Zpět"
	}
}
